import { Button, Flex } from "@mantine/core";
import Lottie from "lottie-react";
import { CSSProperties, useState } from "react";
import ErrorLottie from "./assets/error.json";

function Error({ size = 32, style }) {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <Flex
      h={"90%"}
      align={"center"}
      justify={"center"}
      direction="column"
      style={style}
    >
      <Lottie
        animationData={ErrorLottie}
        loop={true}
        style={{
          height: size * 10,
          width: size * 10,
        }}
      />
      <Button
        onClick={() => {
          setIsLoading(true);
          window.location.reload();
        }}
        gradient={{ from: "#ed6ea0", to: "#ec8c69", deg: 35 }}
        color="red"
        loading={isLoading}
      >
        Try Again
      </Button>
    </Flex>
  );
}

export default Error;
